// import gsap from 'gsap';

/**
 * Splideのアクティブスライド連動型テキストアニメーション
 */
export class HoverMoveImage {
  constructor() {
    this.DOM = {};
    this.DOM.moveLinks = document.querySelectorAll('[data-hover-move]');

    if (this.DOM.moveLinks.length === 0) return;

    this.init();
  }

  init() {

    this.DOM.moveLinks.forEach((link) => {
      const img = link.querySelector('[data-hover-move-image]');
      if (!img) return;

      // エリア内でマウスが動いたとき
      link.addEventListener('mousemove', (e) => {
        const rect = link.getBoundingClientRect();
        
        // エリア内のカーソル位置（中心を 0 とした -1 〜 1 の相対数値）を計算
        const x = ((e.clientX - rect.left) / rect.width) * 2 - 1;
        const y = ((e.clientY - rect.top) / rect.height) * 2 - 1;

        // CSS変数にセット
        img.style.setProperty('--mx', x.toFixed(2));
        img.style.setProperty('--my', y.toFixed(2));
      });

      // マウスが離れたら位置をリセット
      link.addEventListener('mouseleave', () => {
        img.style.setProperty('--mx', '0');
        img.style.setProperty('--my', '0');
      });
    });
  }

}
